<template>
  <div class="page-activity">
    <div class="calendar-content">
        <div class="top-header" @click="handleChangeTab">
          <van-icon size="18" name="calendar-o" />
          <div style="margin-left: 4px">
            周课表
          </div>
      </div>
      <van-calendar
        :show-title="false"
        :poppable="false"
        :min-date="minDate"
        :show-confirm="false"
        row-height="36"
        switch-mode="month"
        @select="handleSelectDate"
      />
    </div>

    <div class="calendar-list">
      <div class="content-item" v-for="(item,index) in state.list" :key="index">
        <div class="left-dot" :style="{background: classStatusColorMap[item.classStatus]}"></div>
        <div class="right-card">
          <div class="card-left-time">
            <div style="height: 16px;line-height: 16px;">{{ getDateMon(item.startTime) }}</div>
            <div style="height: 16px;line-height: 16px;">-</div>
            <div style="height: 16px;line-height: 16px;">{{ getDateMon(item.endTime) }}</div>
          </div>
          <div class="line-com"></div>
          <div class="right-content">
            <div class="course-name">{{ item.courseName ?? "--" }}</div>
            <div class="teacher-name">{{ item.className ?? "--" }}</div>
          </div>
          <van-image
            width="68"
            height="22"
            class="status-img"
            fit="cover"
            :src="classStatusImgMap[item.classStatus]"
          />
          <div class="status-text">{{classStatusMap[item.classStatus]}}</div>
        </div>
       </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted, reactive, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { querySyLessonsList } from "@/api/user";
import dayjs from "dayjs";
import CompletedClass from "@/assets/calendar/completedClass.png"
import InClass from "@/assets/calendar/inClass.png"
import WatingClass from "@/assets/calendar/watingClass.png"

const classStatusMap = {
  1: "上课中",
  2: "待上课",
  3: "已结束",
};

const classStatusImgMap = {
  1: InClass,
  2: WatingClass,
  3: CompletedClass
}

const classStatusColorMap = {
  1: '#4889D9',
  2: '#9F9F9F',
  3: '#5EB758'
}



export default defineComponent({
  name: "TeacherLesson",

  components: {},

  setup() {
    const route = useRoute();
    const router = useRouter();

    const state = reactive({
      classLesson: null,
      list: [],
      className: null,
      minDate: new Date(2022, 0, 1),
      params: {
        userId: route?.query?.userId,
        startDate: dayjs().format("YYYY-MM-DD"),
        endDate: dayjs().format("YYYY-MM-DD"),
      }
    });



    onMounted(() => {
      if (route?.query?.token) {
        localStorage.setItem("token", route?.query?.token);
      }
      queryClassDetailData();
    });

    const queryClassDetailData = async () => {
      try {
        const result = await querySyLessonsList({
          ...state.params
        });
        console.log(result);
        if (result.code === "00") {
          state.list = result?.data ?? []
          state.className = result?.data?.[0].className
        } else {
          state.list = []
        }
      } catch (error) {
        console.log("error:>>>", error);
        state.list = []
      }
    };

    const getDateMon = (value) => {
      return dayjs(`${dayjs().format('YYYY-MM-DD')} ${value}`).format('HH:mm')
    }

    const handleSelectDate = (options) => {
      console.log('options>>>>>',options)
      state.params.startDate = dayjs(options).format("YYYY-MM-DD");
      state.params.endDate = dayjs(options).format("YYYY-MM-DD");
    
      queryClassDetailData();
    }

    const handleChangeTab = () => {
      router.push({
        path: "/weekSchedule",
        query: {
          ...route?.query
        },
      });
    }

    return {
      state,
      classStatusMap,
      handleSelectDate,
      getDateMon,
      handleChangeTab,
      classStatusImgMap,
      classStatusColorMap
    };
  },
});
</script>

<style lang="scss" scoped>
.page-activity {
  background: #e9f1f8;
  height: 100vh;
  width: 100%;
  overflow-y: scroll;
  padding: 0;
  margin: 0;
}

.calendar-content {
}

.left-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.right-card {
  height: 77px;
  width: calc(100% - 20px);
  background: #fff;
  margin-left: 6px;
  border-radius: 8px;
  display: flex;
  position: relative;
}

.card-left-time {
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 17px;
  color: #000000;
  padding-left: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.line-com {
  width: 1px;
  height: 77px;
  background: #F2F1F0;
  margin-left: 16px;
}

.right-content {
  margin-left: 10px;
}

.course-name {
  font-family: PingFang SC;
  font-weight: 800;
  font-size: 17px;
  color: #313131;
  margin-top: 12px;
}
.teacher-name {
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #313131;
  margin-top: 8px;
}

.status-img {
  position: absolute;
  top: 0;
  right: 0;
}

.status-text {
  position: absolute;
  top: 0;
  right: 0;
  width: 52px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  vertical-align: middle;
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 12px;
  color: #FFFFFF;
}



.content-item {
  margin: 12px 8px;
  border-radius: 4px;
  text-align: left;
  display: flex;
  align-items: center;
}

.item-header-info {
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
  align-items: center;

  .item-des {
    color: #333333;
    font-size: 14px;
    vertical-align: middle;
  }

  .item-header-info-name {
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 18px;
    color: #000000;
    font-weight: 600;

    span {
      font-size: 16px;
      font-weight: 500;
      color: burlywood;
    }
  }

  .item-header-info-status {
    color: #fff;
    font-size: 14px;
    background: #113050;
    padding: 4px 12px;
    border-radius: 24px;
  }

  &-text {
    color: #113050;
    font-size: 12px;
    padding: 4px 12px;
  }

  &-value {
    font-size: 12px;
    padding: 4px 12px;
  }

  .item-header-info-other {
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    display: flex;
    align-items: center;

    p {
      color: #ff3638;
    }
  }
}
.top-header {
  height: 32px;
  margin-right: 12px;
  font-size: 12px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>